module.exports = __webpack_public_path__ + "static/media/ipad2-inverted.620bec46.png";